/**
 * OverrideFlag — amber flag marking a limit that differs from the plan default.
 * Tooltip lists the diff(s). Renders nothing when there is nothing to flag.
 */

import { Flag } from "@phosphor-icons/react";
import HoverTip from "../../../../../components/ui/HoverTip";
import { LIMIT_LABELS, LIMIT_ROWS, formatLimitValue } from "../clinicDetailConstants";

const rowByKey = Object.fromEntries(LIMIT_ROWS.map((r) => [r.key, r]));

/** "SMS בחודש: 500 (מסלול 250)" */
export const describeDiff = (d) => {
  const row = rowByKey[d.key] || { type: "int" };
  return `${LIMIT_LABELS[d.key] || d.key}: ${formatLimitValue(row, d.effective)} (מסלול ${formatLimitValue(row, d.planDefault)})`;
};

export default function OverrideFlag({ diffs = [], size = 12, label, className = "" }) {
  if (!diffs.length) return null;
  const text = diffs.map(describeDiff).join(" · ");
  return (
    <HoverTip text={text}>
      <span className={`ncd2-flag ${className}`} aria-label={text}>
        <Flag size={size} weight="fill" />
        {label != null && <span className="ncd2-flag-label">{label}</span>}
      </span>
    </HoverTip>
  );
}
